// extracted by mini-css-extract-plugin
export default {"corpVerifyCode":"corp-verify-code-module--corp-verify-code--hEoFJ"};